import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { session, bootstrapping } = useAuth();
  const location = useLocation();
  const [hasRenderedChildren, setHasRenderedChildren] = useState(false);

  useEffect(() => {
    if (session) {
      setHasRenderedChildren(true);
    } else {
      setHasRenderedChildren(false);
    }
  }, [session]);

  if (bootstrapping && !hasRenderedChildren) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-500"></div>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
